import {Spinner} from '@fluentui/react';
import {FC, useEffect, useMemo, useState} from 'react';
import {sortByTitle} from '../../../../../../helpers/arrayMehods';
import { Activity} from '../../../../../../models';
import {EnhancedDetailsList, OtherColumn} from '../../../../../common/EnhancedDetailsList';
import {SpecialColumnKey} from '../../../../../common/EnhancedDetailsList/IEnhancedDetailsList';
import { EnhancedRemoveButton } from '../../../../../common/EnhancedDetailsList/EnchancedRemoveButton';
import { IProcessRowActivitiesProps } from './IProcessRowActivitiesProps';
import { useActivities } from '../../../../../../hooks/services/useActivities';
import { getColumnsAdd } from '../../../../../common/ProcessSections/activitiesListColumns';

function mapRemovedActivityToActivity(changedItem: Activity): Activity {
  return changedItem;
}

export const ProcessRowRemoveActivities: FC<IProcessRowActivitiesProps> = ({model, disabled, isInput, unitId}) => {
  const {getActivityInputs, getActivityOutputs} = useActivities();
  useEffect(() => {
    (async () => {
      setIsLoading(true);
      const activitiesResponse = await (isInput ? getActivityInputs(unitId) : getActivityOutputs(unitId));
      if (!activitiesResponse.result) return;
      setActivities(activitiesResponse.result.sort(sortByTitle));
      setIsLoading(false);
    })();
  }, [getActivityInputs,getActivityOutputs, isInput, unitId]);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [activities, setActivities] = useState<Activity[]>([]);
  const [newItemsIds, setNewItemsIds] = useState<number[]>([]);
  const columnsAdd = useMemo(
    () => [
      {
        key: SpecialColumnKey.Remove,
        name: '',
        isResizable: false,
        minWidth: 90,
        maxWidth: 90,
        onRender: (item: Activity) => (
          <EnhancedRemoveButton
            item={item}
            removedIds={newItemsIds}
            removeElement={newItem => {
              const mappedItem = newItem;
              mappedItem.active = true;
              if (isInput) {
                model.removedActivityInputs.push(newItem);
              } else {
                model.removedActivityOutputs.push(newItem);
              }
              setNewItemsIds([...newItemsIds, newItem.id]);
            }}
            disabled={disabled}
          />
        ),
        data: OtherColumn
      },
      
      ...getColumnsAdd(isInput ? model.removedActivityInputs as any : model.removedActivityOutputs as any)
    ],
    [newItemsIds, setNewItemsIds, disabled, model, isInput]
  );
  return isLoading ? (
    <Spinner />
  ) : (
    <EnhancedDetailsList<Activity, Activity, Activity>
      items={activities}
      allowAdd
      isAddModal
      columns={columnsAdd}
      changedItems={isInput ? model.removedActivityInputs : model.removedActivityOutputs}
      mapChangedItemToItem={mapRemovedActivityToActivity}
      newItemsIds={newItemsIds}
      pageSize={5}
    />
  );
};
